/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodDrinkAlcoGlassWineIcon24Regular = forwardRef('FoodDrinkAlcoGlassWineIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.25 4.5A2.25 2.25 0 0 1 5.5 2.25h13a2.25 2.25 0 0 1 2.25 2.25v2.75a8.75 8.75 0 0 1-8 8.718v4.282h5a.75.75 0 0 1 0 1.5H6.25a.75.75 0 0 1 0-1.5h5v-4.282a8.75 8.75 0 0 1-8-8.718V4.5Zm2.25-.75a.75.75 0 0 0-.75.75v2.75h14.5V4.5a.75.75 0 0 0-.75-.75h-13Zm13.595 5H4.905a7.253 7.253 0 0 0 14.19 0Z" })));
});
